(function(){
  document.addEventListener("DOMContentLoaded", function() {
      var url = new URL(window.location.href);
      var params = new URLSearchParams(url.search);
      if (params.has('variant')) {
          params.delete('variant');
          var newUrl = url.origin + url.pathname + '?' + params.toString();
          if (params.toString() === '') {
              newUrl = url.origin + url.pathname; // Remove the '?' if there are no other query parameters
          }
          window.history.replaceState(null, null, newUrl);
      }
    setupTitleObserver();
    setupPopupCustomerNames();
  });
})();

function setupPopupCustomerNames() {
  const firstNames = ["Sarah M.", "Jessica T.", "Michael B.", "David R.", "Emily K.", "James L.", "Amanda W.", "Daniel H.", "Ashley C.", "Matthew P.", "Olivia S.", "Joshua M.", "Sophia E.", "Andrew G.", "Emma F."];
  
  function replaceCustomerText() {
    const popups = document.querySelectorAll('div[class*="recent"], div[class*="notification"], div[class*="popup"], div[class*="sales-pop"]');
    popups.forEach(popup => {
      const walker = document.createTreeWalker(popup, NodeFilter.SHOW_TEXT, null, false);
      let node;
      while (node = walker.nextNode()) {
        if (node.nodeValue.includes("Customer recently purchased")) {
          const randomName = firstNames[Math.floor(Math.random() * firstNames.length)];
          node.nodeValue = node.nodeValue.replace("Customer recently purchased", randomName + " recently purchased");
        }
      }
    });
  }

  const observer = new MutationObserver(replaceCustomerText);
  observer.observe(document.body, { childList: true, subtree: true });
}
function setupTitleObserver() {
    // Function to add the custom link
    function addCustomLink() {
        // Add custom link to sidebar
            const linkDiv = document.querySelector(
                ".npc-sidebar-container .npc-title.npc-selections-text-title"
            );
            if (linkDiv && !document.getElementById('npc-selections-text-anchortag-link')) {
                const anchorTag = document.createElement("a");
                anchorTag.href = "https://ledneons.com/pages/neon-sign";
                anchorTag.id = "npc-selections-text-anchortag-link";
                anchorTag.innerHTML = "Custom Logo / Design";
                anchorTag.addEventListener('click', (e) => {
                    e.preventDefault(); // Prevents default link behavior
                    const neonCustomiserApp = document.getElementById('neon-customiser-app');
                    const customizerLeadForm = document.getElementById('customizer-lead-form');
                    if (neonCustomiserApp) {
                        neonCustomiserApp.style.setProperty('display', 'none', 'important');
                        if (neonCustomiserApp.parentElement) {
                            neonCustomiserApp.parentElement.style.setProperty('display', 'none', 'important');
                            neonCustomiserApp.parentElement.classList.add('d-none');
                        }
                        customizerLeadForm.classList.remove('d-none');
                    }
                });
                linkDiv.appendChild(anchorTag);
            }
    }
    // Try to add the link immediately
    if (addCustomLink()) {
        // Link added successfully
    } else {
        // Set up a dedicated MutationObserver for just the title element
        const titleObserver = new MutationObserver((mutations, obs) => {
            if (document.querySelector(".npc-sidebar-container .npc-title.npc-selections-text-title")) {
                if (addCustomLink()) {
                    obs.disconnect();
                }
            }
        });
        // Start observing for the title element
        titleObserver.observe(document.body, {
            childList: true,
            subtree: true
        });
        // Also try with a few delays
        setTimeout(() => {
            if (addCustomLink()) {
                titleObserver.disconnect();
            }
        }, 1000);
        setTimeout(() => {
            if (addCustomLink()) {
                titleObserver.disconnect();
            }
        }, 3000);
    }
}
   (function() {
    function initializeFeatures() {
        try {
            // Add custom link to sidebar
            const linkDiv = document.querySelector(
                ".npc-sidebar-container .npc-title.npc-selections-text-title"
            );
            if (linkDiv && !document.getElementById('npc-selections-text-anchortag-link')) {
                const anchorTag = document.createElement("a");
                anchorTag.href = "https://ledneons.com/pages/neon-sign";
                anchorTag.id = "npc-selections-text-anchortag-link";
                anchorTag.innerHTML = "Custom Logo / Design";
                anchorTag.addEventListener('click', (e) => {
                    e.preventDefault(); // Prevents default link behavior
                    const neonCustomiserApp = document.getElementById('neon-customiser-app');
                    const customizerLeadForm = document.getElementById('customizer-lead-form');
                    if (neonCustomiserApp) {
                        neonCustomiserApp.style.display = 'none';
                        customizerLeadForm.classList.remove('d-none');
                    }
                });
                linkDiv.appendChild(anchorTag);
            }
            // Get required elements
            const doneButton = document.querySelector(
                ".template-page .main-content#MainContent .npc-sidebar-price-button-container .npc-sidebar-price-button.tw-bg-secondary"
            );
            const floatingButton = document.querySelector("#floatingProductButton button");
            const floatingButtonProductPrice = floatingButton?.querySelector('#floatingButtonProductPrice');
            const userTextarea = document.querySelector(
                "#neon-customiser-app .npc-selections-text-form textarea"
            );
            const productPrice = document?.querySelector('#neon-customiser-app .npc-price.npc-sidebar-price span');
           if(doneButton){
              doneButton.addEventListener("click", () => {
                // gtag_report_conversion_customizer(); 
            });
           }
            if(doneButton && doneButton.innerHTML == 'Done'){
              doneButton.innerHTML = '<span> Buy Now </span>'
            }
            // Initialize floating button state
            if (floatingButton) {
                floatingButton.disabled = true;
                floatingButton.classList.add('disabled');
            }
            // Function to update floatingButtonProductPrice when productPrice changes
            function updateFloatingPrice() {
                if (productPrice && floatingButtonProductPrice) {
                    floatingButtonProductPrice.innerHTML = productPrice.innerHTML;
                }
            }
            // Use MutationObserver to watch for changes in productPrice
            if (productPrice) {
                const observer = new MutationObserver(updateFloatingPrice);
                observer.observe(productPrice, { childList: true, subtree: true });
            }
            // Set up textarea event listener
            if (doneButton && floatingButton && userTextarea) {
                const handleTextareaInput = (e) => {
                    let userInputValue = e.target.value.trim();
                    if (userInputValue.length >= 3) {
                        floatingButton.disabled = false;
                        floatingButton.classList.remove('disabled');
                        updateFloatingPrice(); // Ensure price updates when textarea is valid
                        floatingButton.addEventListener("click", () => {
                            // gtag_report_conversion_customizer();
                            doneButton.click();
                        }, { once: true }); // Use once: true to prevent multiple listeners
                    } else {
                        floatingButton.disabled = true;
                        floatingButton.classList.add('disabled');
                        floatingButtonProductPrice.innerHTML = '$0.00';
                    }
                };
                userTextarea.addEventListener('input', handleTextareaInput);
                if (window.matchMedia("(max-width: 768px)").matches) { 
                    userTextarea.addEventListener('focus', () => {
                        setTimeout(() => {
                            document.getElementById('HeaderWrapper').scrollIntoView({ behavior: 'smooth', block: 'center' });
                        }, 300);
                    });
                }
                // Trigger input event to set initial state
                userTextarea.dispatchEvent(new Event('input'));
            }
        } catch (error) {
            console.error("Error in initializeFeatures:", error);
        }
    }
    initializeFeatures();
    // Function to check if all required elements are present
    function checkElements() {
        const requiredSelectors = [
            ".template-page .main-content#MainContent .npc-sidebar-price-button-container .npc-sidebar-price-button.tw-bg-secondary",
            "#floatingProductButton button",
            "#neon-customiser-app .npc-selections-text-form textarea"
        ];
      
        return requiredSelectors.every(selector => document.querySelector(selector));
    }
    // Set up MutationObserver to watch for DOM changes
    const observerButtons = new MutationObserver((mutations, obs) => {
        if (checkElements()) {
            initializeFeatures();
            obs.disconnect(); // Stop observing once elements are found
        }
    });
    // Start observing
    observerButtons.observe(document.body, {
        childList: true,
        subtree: true,
    });
    // Try to initialize on window load with delay options
    window.addEventListener('load', () => {
        if (checkElements()) {
            initializeFeatures();
            observerButtons.disconnect();
        } else {
            // Try again after a short delay
            setTimeout(() => {
                if (checkElements()) {
                    initializeFeatures();
                    observerButtons.disconnect();
                } else {
                    // Try one more time with a longer delay
                    setTimeout(() => {
                        if (checkElements()) {
                            initializeFeatures();
                        }
                        observerButtons.disconnect();
                    }, 5000);
                }
            }, 2000);
        }
    });
})();
  (function () {
  try {
    const safeLineLimitObserver = new MutationObserver(() => {
      try {
        const formParent = document.querySelector('.npc-selections-text-form');
        if (formParent && !document.getElementById('line-limit-message-custom')) {
          const infoMessage = document.createElement('p');
          infoMessage.id = 'line-limit-message-custom';
          infoMessage.textContent = 'You can add up to 3 lines of Text.';
          infoMessage.style.paddingLeft = '8px';
          infoMessage.style.fontFamily = 'var(--npc-font),sans-serif';
          infoMessage.style.fontSize = '.75em';
          infoMessage.style.color = '#ffffff';
          formParent.appendChild(infoMessage);
          const alignmentParent = document.querySelector('.npc-alignment');
          if (alignmentParent && alignmentParent.children.length >= 2) {
            alignmentParent.children[1].click();
          }
          const done_Button = document.querySelector(
                ".template-page .main-content#MainContent .npc-sidebar-price-button-container .npc-sidebar-price-button"
            );
          const userTextarea = document.querySelector(
                "#neon-customiser-app .npc-sidebar #npc-text-area"
            );
          done_Button.addEventListener("click", () => {
                    // gtag_report_conversion_customizer(); 
                });
            if (window.matchMedia("(max-width: 768px)").matches) { 
                    userTextarea.addEventListener('focus', () => {
                        setTimeout(() => {
                            const headerWrapper = document.getElementById('HeaderWrapper');
                            if (headerWrapper) {
                                headerWrapper.scrollIntoView({ behavior: 'smooth', block: 'center' });
                            }
                        }, 300);
                    });
                }
          safeLineLimitObserver.disconnect();
        }
        // restrictBackspaceBehavior()
      } catch (innerError) {
        console.error('[LineLimitInjectionError]: Failed to inject line limit message.', innerError);
      }
    });
    safeLineLimitObserver.observe(document.body, {
      childList: true,
      subtree: true,
    });
  } catch (outerError) {
    console.error('[LineLimitObserverError]: Failed to set up MutationObserver.', outerError);
  }
})();
function prosemirrorDetector() {
  // Target node to observe — adjust if you know the specific container
  const prosemirrorTargetNode = document.body;
  // Observer configuration
  const prosemirrorConfig = {
    attributes: true,
    subtree: true,
    attributeFilter: ['class']
  };
  // Callback function for mutations
  const prosemirrorCallback = function(prosemirrorMutationsList) {
    for (const prosemirrorMutation of prosemirrorMutationsList) {
      if (prosemirrorMutation.type === 'attributes') {
        const prosemirrorTarget = prosemirrorMutation.target;
        if (prosemirrorTarget.classList.contains('ProseMirror-focused')) {
          if (window.matchMedia("(max-width: 768px)").matches) { 
                        setTimeout(() => {
                            const headerWrapper = document.getElementById('HeaderWrapper');
                            if (headerWrapper) {
                                headerWrapper.scrollIntoView({ behavior: 'smooth', block: 'center' });
                            }
                        }, 300);
                }
        }
      }
    }
  };
  // Create the observer
  const prosemirrorObserver = new MutationObserver(prosemirrorCallback);
  // Start observing
  prosemirrorObserver.observe(prosemirrorTargetNode, prosemirrorConfig);
  // Optional: return the observer so you can disconnect or manage later
  return prosemirrorObserver;
}
const prosemirrorObserverInstance = prosemirrorDetector();


document.addEventListener("DOMContentLoaded", () => {
  const section = document.querySelector("#neon-customiser-app");
  if (!section) return;

  let chatbotStored = null;
  let originalParent = null;

  // --- Throttle helper ---
  function throttle(func, limit) {
    let inThrottle;
    return function () {
      if (!inThrottle) {
        func.apply(this, arguments);
        inThrottle = true;
        setTimeout(() => (inThrottle = false), limit);
      }
    };
  }

  // --- Scroll logic ---
  const checkScroll = () => {
    if (!chatbotStored) return;

    const rect = section.getBoundingClientRect();
    const sectionBottom = rect.bottom;

    // Trigger when bottom of section reaches 90% of viewport height
    const passed90 = sectionBottom <= window.innerHeight * 0.8;

    if (passed90) {
      // ✅ Show chatbot
      if (!document.body.contains(chatbotStored)) {
        (originalParent || document.body).appendChild(chatbotStored);
      }
    } else {
      // ❌ Hide chatbot
      if (document.body.contains(chatbotStored)) {
        chatbotStored.remove();
      }
    }
  };

  const throttledCheck = throttle(checkScroll, 150);

  // --- Slider fill logic ---
  const sliderSelector = ".npc-selections-slider-input";
  const initialisedSliders = new WeakSet();

  const updateSliderFill = (slider) => {
    const min = +slider.min || 0;
    const max = +slider.max || 100;
    const value = +slider.value;
    const pct = max === min ? 0 : ((value - min) / (max - min)) * 100;
    slider.style.setProperty("--slider-fill-percent", `${pct}%`);
  };

  const initSlider = (slider) => {
    if (initialisedSliders.has(slider)) return;
    initialisedSliders.add(slider);

    updateSliderFill(slider);
    slider.addEventListener("input", () => updateSliderFill(slider));
    // 'change' covers programmatic value updates that dispatch a change event
    slider.addEventListener("change", () => updateSliderFill(slider));
  };

  // Initialise any sliders already in the DOM
  document.querySelectorAll(sliderSelector).forEach(initSlider);

  // --- MutationObserver: chatbot + sliders ---
  // We keep observing for sliders since the customiser may re-render them,
  // but stop watching for the chatbot once we've grabbed it.
  let chatbotFound = false;

  const domObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType !== 1) return; // element nodes only

        // Chatbot detection
        if (
          !chatbotFound &&
          node.matches &&
          node.matches("inbox-online-store-chat#ShopifyChat")
        ) {
          chatbotStored = node;
          originalParent = node.parentNode || document.body;
          node.remove();
          checkScroll();
          chatbotFound = true;
        }

        // Slider detection — the node itself…
        if (node.matches && node.matches(sliderSelector)) {
          initSlider(node);
        }
        // …or sliders nested inside the added subtree
        if (node.querySelectorAll) {
          node.querySelectorAll(sliderSelector).forEach(initSlider);
        }
      });
    });
  });

  domObserver.observe(document.body, { childList: true, subtree: true });

  // --- Scroll + resize handlers ---
  window.addEventListener("scroll", throttledCheck);
  window.addEventListener("resize", throttledCheck);
});


/// Global object to store submission data
window.klaviyoFormSubmission = {};

// Debouncing variables
let klaviyoEmailDebounceTimer = null;
let klaviyoTextDebounceTimer = null;
const KLAVIYO_DEBOUNCE_DELAY = 1000;

// Store previous values to detect actual changes
let klaviyoPreviousValues = {};

function klaviyoHasDataChanged(key, newValue) {
  const previousValue = klaviyoPreviousValues[key];
  const hasChanged = previousValue !== newValue;
  
  if (hasChanged) {
    klaviyoPreviousValues[key] = newValue;
  }
  
  return hasChanged;
}

function klaviyoSaveData(key, value, source = "input") {
  if (!value) return false;

  // Check if the value has actually changed
  if (!klaviyoHasDataChanged(key, value)) {
    console.log(`[KlaviyoAPI] No change detected for ${key}, skipping save`);
    return false;
  }

  window.klaviyoFormSubmission = {
    ...window.klaviyoFormSubmission,
    [key]: value,
    klaviyoLastUpdated: new Date().toISOString(),
    klaviyoSource: source,
  };

  localStorage.setItem("klaviyoFormSubmission", JSON.stringify(window.klaviyoFormSubmission));
  console.log(`[KlaviyoAPI] Data updated for ${key}:`, value);
  return true;
}

function klaviyoSendDataToAPI(reason = "auto") {
  const klaviyoData = JSON.parse(localStorage.getItem("klaviyoFormSubmission") || "{}");
  if (!klaviyoData.klaviyoEmail) {
    console.log("[KlaviyoAPI] No email found, skipping API call");
    return;
  }

  const isUpdate = klaviyoData.recordId ? true : false;
  const endpoint = isUpdate 
    ? `https://copy-lead.marke-ter.online/api/update/${klaviyoData.recordId}`
    : "https://copy-lead.marke-ter.online/api/capture";
  
  const method = isUpdate ? "PUT" : "POST";

  console.log(`[KlaviyoAPI] Sending ${method} request for reason: ${reason}`);

  fetch(endpoint, {
    method: method,
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      ...klaviyoData,
      klaviyoEvent: reason,
    }),
    keepalive: true,
  })
  .then(response => response.json())
  .then(data => {
    if (!isUpdate && data.status === 'success' && data.recordId) {
      window.klaviyoFormSubmission.recordId = data.recordId;
      localStorage.setItem("klaviyoFormSubmission", JSON.stringify(window.klaviyoFormSubmission));
    }
    console.log(`[KlaviyoAPI] ${isUpdate ? 'Update' : 'Create'} successful:`, data);
  })
  .catch((err) => console.error(`[KlaviyoAPI] ${isUpdate ? 'Update' : 'Create'} failed:`, err));
}

// ---------------- Email ----------------
function klaviyoAttachEmailListeners(klaviyoForm) {
  const klaviyoEmailInput = klaviyoForm.querySelector('input[name="email"]');
  if (!klaviyoEmailInput) return;

  klaviyoEmailInput.addEventListener("input", function () {
    const emailValue = klaviyoEmailInput.value.trim();
    const dataChanged = klaviyoSaveData("klaviyoEmail", emailValue, "email-typing");

    if (klaviyoEmailDebounceTimer) clearTimeout(klaviyoEmailDebounceTimer);
    
    // Only set timer if data actually changed and email is valid
    if (dataChanged && emailValue) {
      klaviyoEmailDebounceTimer = setTimeout(() => {
        klaviyoSendDataToAPI("email-input");
      }, KLAVIYO_DEBOUNCE_DELAY);
    }
  });

  klaviyoEmailInput.addEventListener("blur", function () {
    const emailValue = klaviyoEmailInput.value.trim();
    if (emailValue && klaviyoEmailDebounceTimer) {
      clearTimeout(klaviyoEmailDebounceTimer);
      klaviyoEmailDebounceTimer = null;
      klaviyoSendDataToAPI("email-blur");
    }
  });
}

// ---------------- Text Box ----------------
function klaviyoAttachTextBoxListeners(klaviyoEditableDiv) {
  function klaviyoGetText() {
    return klaviyoEditableDiv.innerText.trim();
  }

  klaviyoEditableDiv.addEventListener("input", () => {
    const textValue = klaviyoGetText();
    const dataChanged = klaviyoSaveData("klaviyoUserText", textValue, "textbox-input");

    if (dataChanged && window.klaviyoFormSubmission?.klaviyoEmail) {
      if (klaviyoTextDebounceTimer) clearTimeout(klaviyoTextDebounceTimer);
      klaviyoTextDebounceTimer = setTimeout(() => {
        klaviyoSendDataToAPI("textbox-input");
      }, KLAVIYO_DEBOUNCE_DELAY);
    }
  });

  klaviyoEditableDiv.addEventListener("blur", () => {
    if (window.klaviyoFormSubmission?.klaviyoEmail && klaviyoTextDebounceTimer) {
      clearTimeout(klaviyoTextDebounceTimer);
      klaviyoTextDebounceTimer = null;
      klaviyoSendDataToAPI("textbox-blur");
    }
  });
}

// ---------------- Size ----------------
function klaviyoAttachSizeListeners(sizeContainer) {
  const sizeButtons = sizeContainer.querySelectorAll(".npc-selection-button");
  sizeButtons.forEach((btn) => {
    btn.addEventListener("click", () => {
      const label = btn.querySelector(".npc-selection-button-title")?.innerText.trim() || "";
      const dataChanged = klaviyoSaveData("klaviyoSize", label, "size-select");
      
      if (dataChanged && window.klaviyoFormSubmission?.klaviyoEmail) {
        klaviyoSendDataToAPI("size-select");
      }
    });
  });
}

// ---------------- Material ----------------
function klaviyoAttachMaterialListeners(materialContainer) {
  const materialButtons = materialContainer.querySelectorAll(".npc-selection-button");
  materialButtons.forEach((btn) => {
    btn.addEventListener("click", () => {
      const label = btn.querySelector(".npc-selection-button-title")?.innerText.trim() || "";
      const dataChanged = klaviyoSaveData("klaviyoMaterial", label, "material-select");
      
      if (dataChanged && window.klaviyoFormSubmission?.klaviyoEmail) {
        klaviyoSendDataToAPI("material-select");
      }
    });
  });
}

// ---------------- Backboard ----------------
function klaviyoAttachBackboardListeners(backboardContainer) {
  const backboardButtons = backboardContainer.querySelectorAll(".npc-selection-button");
  backboardButtons.forEach((btn) => {
    btn.addEventListener("click", () => {
      const label = btn.querySelector(".npc-selection-button-title")?.innerText.trim() || "";
      const dataChanged = klaviyoSaveData("klaviyoBackboard", label, "backboard-select");
      
      if (dataChanged && window.klaviyoFormSubmission?.klaviyoEmail) {
        klaviyoSendDataToAPI("backboard-select");
      }
    });
  });
}

// ---------------- Jacket ----------------
function klaviyoAttachJacketListeners(jacketContainer) {
  const jacketButtons = jacketContainer.querySelectorAll(".npc-selection-button");
  jacketButtons.forEach((btn) => {
    btn.addEventListener("click", () => {
      const titleEl = btn.querySelector(".npc-selection-button-title");
      const subtitleEl = btn.querySelector(".npc-selection-button-subtitle");

      const jacketLabel = titleEl ? titleEl.innerText.trim() : "";
      const jacketValue = subtitleEl ? subtitleEl.innerText.trim() : "";

      const labelChanged = klaviyoSaveData("klaviyoJacket", jacketLabel, "jacket-select");
      const valueChanged = klaviyoSaveData("klaviyoJacketValue", jacketValue, "jacket-select");

      if ((labelChanged || valueChanged) && window.klaviyoFormSubmission?.klaviyoEmail) {
        klaviyoSendDataToAPI("jacket-select");
      }
    });
  });
}

// ---------------- Backboard Color ----------------
function klaviyoAttachBackboardColorListeners(backboardColorContainer) {
  const colorButtons = backboardColorContainer.querySelectorAll(".npc-preview-selector");

  colorButtons.forEach((btn, idx) => {
    btn.addEventListener("click", () => {
      // Extract image URL from the span's background
      const bgStyle = btn.querySelector("span")?.getAttribute("style") || "";
      const imageUrlMatch = bgStyle.match(/url\(["']?(.*?)["']?\)/);
      const colorImageUrl = imageUrlMatch ? imageUrlMatch[1] : "";

      // Extract color name from the example div
      const labelEl = backboardColorContainer.querySelector(".tw-flex.tw-text-left");
      const colorName = labelEl ? labelEl.textContent.trim() : `Option ${idx + 1}`;

      // Save the selection
      klaviyoSaveData("klaviyoBackboardColor", colorName, "backboard-color-select");
      klaviyoSaveData("klaviyoBackboardColorImage", colorImageUrl, "backboard-color-select");

      // Send update if email exists
      if (window.klaviyoFormSubmission?.klaviyoEmail) {
        klaviyoSendDataToAPI("backboard-color-select");
      }
    });
  });
}


// ---------------- Color ----------------
function klaviyoAttachColorListeners(colorContainer) {
  const colorButtons = colorContainer.querySelectorAll(".npc-preview-selector");

  colorButtons.forEach((btn) => {
    btn.addEventListener("click", () => {
      const span = btn.querySelector("span");
      if (!span) return;

      // Get color value from inline style
      const colorStyle = span.getAttribute("style") || "";
      const colorValue = colorStyle.replace("background:", "").trim().replace(";", "");

      // Also try to capture a label if available (e.g. "Hot Pink")
      const labelEl = colorContainer.querySelector(".tw-flex.tw-text-left.tw-font-bold");
      const colorLabel = labelEl ? labelEl.innerText.trim() : colorValue;

      // Save color selection
      const labelChanged = klaviyoSaveData("klaviyoColor", colorLabel, "color-select");
      const valueChanged = klaviyoSaveData("klaviyoColorValue", colorValue, "color-select");

      // Send update only if email already exists and data changed
      if ((labelChanged || valueChanged) && window.klaviyoFormSubmission?.klaviyoEmail) {
        klaviyoSendDataToAPI("color-select");
      }
    });
  });
}

// ---------------- Font ----------------
function applySelectedFontToInput(fontFamily) {
  if (!fontFamily) return;
  document.documentElement.style.setProperty('--npc-selected-font-family', fontFamily);
  const textElements = document.querySelectorAll(
    '#neon-customiser-app #npc-text-area, #neon-customiser-app .npc-selections-text-form textarea, #neon-customiser-app .ProseMirror'
  );
  textElements.forEach((el) => {
    el.style.setProperty('font-family', fontFamily, 'important');
  });
}

function klaviyoAttachFontListeners(fontContainer) {
  const fontButtons = fontContainer.querySelectorAll(".npc-font-button");

  fontButtons.forEach((btn) => {
    btn.addEventListener("click", () => {
      const span = btn.querySelector("span[data-font]");
      if (!span) return;

      const fontKey = span.getAttribute("data-font");
      const fontName = span.innerText.trim();
      const computedFont = window.getComputedStyle(span).fontFamily || fontName;
      applySelectedFontToInput(computedFont);

      // Save font selection
      const nameChanged = klaviyoSaveData("klaviyoFont", fontName, "font-select");
      const keyChanged = klaviyoSaveData("klaviyoFontKey", fontKey, "font-select");

      // Send update only if email already exists and data changed
      if ((nameChanged || keyChanged) && window.klaviyoFormSubmission?.klaviyoEmail) {
        klaviyoSendDataToAPI("font-select");
      }
    });
  });
}

// Global observer for dynamic font button selection sync
(function initFontSelectionObserver() {
  document.addEventListener('DOMContentLoaded', () => {
    const observer = new MutationObserver(() => {
      const selectedBtn = document.querySelector(
        '#neon-customiser-app .npc-font-button.tw-border-primary, #neon-customiser-app .npc-font-button.active, #neon-customiser-app .npc-font-button.selected'
      );
      if (selectedBtn) {
        const span = selectedBtn.querySelector('span[data-font]');
        if (span) {
          const computedFont = window.getComputedStyle(span).fontFamily;
          if (computedFont) {
            applySelectedFontToInput(computedFont);
          }
        }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
  });
})();

// ---------------- Initialize Previous Values ----------------
function klaviyoInitializePreviousValues() {
  const existingData = localStorage.getItem("klaviyoFormSubmission");
  if (existingData) {
    window.klaviyoFormSubmission = JSON.parse(existingData);
    
    // Initialize previous values with existing data
    Object.keys(window.klaviyoFormSubmission).forEach(key => {
      klaviyoPreviousValues[key] = window.klaviyoFormSubmission[key];
    });
    
    console.log("[KlaviyoAPI] Initialized with existing data:", klaviyoPreviousValues);
  }
}

// ---------------- MutationObserver ----------------
const klaviyoDOMObserver = new MutationObserver((klaviyoMutations) => {
  klaviyoMutations.forEach((klaviyoMutation) => {
    klaviyoMutation.addedNodes.forEach((klaviyoNode) => {
      if (klaviyoNode.nodeType === 1) {
        // Email form
        const klaviyoForm =
          klaviyoNode.querySelector?.('[data-testid="klaviyo-form-RyyyMM"]') ||
          (klaviyoNode.matches?.('[data-testid="klaviyo-form-RyyyMM"]') ? klaviyoNode : null);
        if (klaviyoForm) klaviyoAttachEmailListeners(klaviyoForm);

        // Text editor
        const klaviyoEditableDiv =
          klaviyoNode.querySelector?.(".tiptap.ProseMirror") ||
          (klaviyoNode.matches?.(".tiptap.ProseMirror") ? klaviyoNode : null);
        if (klaviyoEditableDiv) klaviyoAttachTextBoxListeners(klaviyoEditableDiv);
        
        // Color selection
        const colorContainer =
          klaviyoNode.querySelector?.(".npc-selections-color") ||
          (klaviyoNode.matches?.(".npc-selections-color") ? klaviyoNode : null);
        if (colorContainer) klaviyoAttachColorListeners(colorContainer);

        // Font selection
        const fontContainer =
          klaviyoNode.querySelector?.(".npc-selections-font-list") ||
          (klaviyoNode.matches?.(".npc-selections-font-list") ? klaviyoNode : null);
        if (fontContainer) klaviyoAttachFontListeners(fontContainer);

        // Size
        const sizeContainer =
          klaviyoNode.querySelector?.(".npc-selections-size") ||
          (klaviyoNode.matches?.(".npc-selections-size") ? klaviyoNode : null);
        if (sizeContainer) klaviyoAttachSizeListeners(sizeContainer);

        // Material
        const materialContainer =
          klaviyoNode.querySelector?.(".npc-selections-material") ||
          (klaviyoNode.matches?.(".npc-selections-material") ? klaviyoNode : null);
        if (materialContainer) klaviyoAttachMaterialListeners(materialContainer);

        // Backboard
        const backboardContainer =
          klaviyoNode.querySelector?.(".npc-selections-backboard") ||
          (klaviyoNode.matches?.(".npc-selections-backboard") ? klaviyoNode : null);
        if (backboardContainer) klaviyoAttachBackboardListeners(backboardContainer);

        // Jacket
        const jacketContainer =
          klaviyoNode.querySelector?.(".npc-selections-jacket") ||
          (klaviyoNode.matches?.(".npc-selections-jacket") ? klaviyoNode : null);
        if (jacketContainer) klaviyoAttachJacketListeners(jacketContainer);

        // Backboard Color
        const backboardColorContainer =
          klaviyoNode.querySelector?.(".npc-selections-backboard-color") ||
          (klaviyoNode.matches?.(".npc-selections-backboard-color") ? klaviyoNode : null);
        if (backboardColorContainer) klaviyoAttachBackboardColorListeners(backboardColorContainer);
      }
    });
  });
});

// ---------------- Init ----------------
klaviyoInitializePreviousValues();
klaviyoDOMObserver.observe(document.body, { childList: true, subtree: true });



// document.addEventListener("DOMContentLoaded", () => {
//   // --- URL guard: only run on the custom neon signs page ---
//   if (window.location.pathname !== "/pages/updated-custom-neon-signs") return;

//   const buttonSelector = ".npc-font-button .fit-text-fonts";
//   const editorSelector = "#npc-text-area .tiptap";

//   let editor = null;
//   const initialisedEditors = new WeakSet();

//   // --- Read current text from the contenteditable ---
//   const getEditorText = (el) => {
//     return (el.textContent || "").trim();
//   };

//   // --- Update every font-preview button to show the given text ---
//   const updateButtonText = (text) => {
//     const buttons = document.querySelectorAll(buttonSelector);
//     buttons.forEach((span) => {
//       if (!span.dataset.originalText) {
//         span.dataset.originalText = span.textContent;
//       }
//       span.textContent = text || span.dataset.originalText;
//     });
//   };

//   // --- Wire up a tiptap editor once it appears ---
//   const initEditor = (el) => {
//     if (initialisedEditors.has(el)) return;
//     initialisedEditors.add(el);
//     editor = el;

//     const initial = getEditorText(el);
//     if (initial) updateButtonText(initial);

//     const editorObserver = new MutationObserver(() => {
//       updateButtonText(getEditorText(el));
//     });

//     editorObserver.observe(el, {
//       childList: true,
//       subtree: true,
//       characterData: true,
//     });

//     el.addEventListener("input", () => {
//       updateButtonText(getEditorText(el));
//     });
//   };

//   const existing = document.querySelector(editorSelector);
//   if (existing) initEditor(existing);

//   const domObserver = new MutationObserver((mutations) => {
//     mutations.forEach((mutation) => {
//       mutation.addedNodes.forEach((node) => {
//         if (node.nodeType !== 1) return;

//         if (node.matches && node.matches(editorSelector)) {
//           initEditor(node);
//         }
//         if (node.querySelector) {
//           const nested = node.querySelector(editorSelector);
//           if (nested) initEditor(nested);
//         }
//       });
//     });
//   });

//   domObserver.observe(document.body, { childList: true, subtree: true });
// });

// Global click-to-zoom functionality with support for dynamically updated/swapped images (e.g. variant changes)
document.addEventListener('DOMContentLoaded', function() {
  const registerZoom = () => {
    const zoomContainers = document.querySelectorAll('.product__media.zoom, #ex1');
    zoomContainers.forEach(container => {
      if (container.dataset.zoomRegistered) return;
      container.dataset.zoomRegistered = "true";

      const img = container.querySelector('img');
      if (!img) return;

      container.addEventListener('click', function(e) {
        if (container.classList.contains('video-option')) return;

        e.preventDefault();
        e.stopPropagation();

        if (container.classList.contains('is-zoomed')) {
          container.classList.remove('is-zoomed');
          img.style.transform = '';
          img.style.transformOrigin = 'center center';
        } else {
          container.classList.add('is-zoomed');
          zoomImage(e);
        }
      });

      container.addEventListener('mousemove', function(e) {
        if (!container.classList.contains('is-zoomed')) return;
        zoomImage(e);
      });

      container.addEventListener('mouseleave', function() {
        if (container.classList.contains('is-zoomed')) {
          container.classList.remove('is-zoomed');
          img.style.transform = '';
          img.style.transformOrigin = 'center center';
        }
      });

      function zoomImage(e) {
        const rect = container.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;
        
        const xPercent = (x / rect.width) * 100;
        const yPercent = (y / rect.height) * 100;
        
        img.style.transformOrigin = `${xPercent}% ${yPercent}%`;
      }
    });
  };

  registerZoom();
  // Watch for DOM changes to auto-bind zoom on swapped elements (like variant changes)
  const observer = new MutationObserver(registerZoom);
  observer.observe(document.body, { childList: true, subtree: true });
});